import * as React from "react";
import styled from "@mui/material/styles/styled";
import { ACTION, CATEGORY, evt } from "fe-common/analytics/analytics";
import { useDiagnosticNavigation } from "../../useDiagnosticNavigation";
import { Fab } from "@mui/material";
import { MobileView } from "../../../../util/aKaunGeneralUtil";
import { useScreenSize } from "../../util/useScreenSize";
import IconButton from "@mui/material/IconButton";
import { AgentTooltip } from "fe-common/ui/AgentTooltip";
import PlusIcon from "../../../../assets/plusThickIcon.svg";
import AddDiseaseIcon from "../../../../assets/addDiseaseIcon.svg";

//region [[ Styles ]]

const AddDiseaseView = styled("div")(({ theme }) => ({}));

const AddDiseaseDesktop = styled(Fab)(({ theme }) => ({
  marginLeft: "10px",
  backgroundColor: "white",
  boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.08)",
}));

const AddDiseaseMobile = styled(IconButton)(({ theme }) => ({
  marginLeft: "10px",
  backgroundColor: "white",

  [theme.breakpoints.up(MobileView)]: {
    backgroundColor: "transparent",
    width: "10px",
    color: "white",
    boxShadow: "none",
    height: "10px",
  },
}));

//endregion [[ Styles ]]

//region [[ Props ]]

export interface AddDiseaseButtonProps {}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const AddDiseaseButton = ({ ...props }: AddDiseaseButtonProps) => {
  const { setAddDiseaseOpen } = useDiagnosticNavigation();
  const { isMobile } = useScreenSize();

  const handleAddDisease = () => {
    evt({
      category: CATEGORY.AGENT_DD_LIST,
      action: ACTION.OPEN_ADD_DISEASE_SEARCH,
    });
    setAddDiseaseOpen(true);
  };
  return (
    <AddDiseaseView>
      {isMobile ? (
        <AddDiseaseMobile onClick={handleAddDisease} size={"small"}>
          <img src={AddDiseaseIcon} alt={"Plus Icon"} />
        </AddDiseaseMobile>
      ) : (
        <AgentTooltip title={"Add Disease"}>
          <AddDiseaseDesktop onClick={handleAddDisease} size={"small"}>
            <img src={PlusIcon} alt={"Plus Icon"} />
          </AddDiseaseDesktop>
        </AgentTooltip>
      )}
    </AddDiseaseView>
  );
};
